export const KINDS = [
  { value: 'bachelor',   text: 'Бакалавриат / Специалитет' },
  { value: 'magistrant', text: 'Магистратура' },
  { value: 'aspirant',   text: 'Аспирантура' },
]

export const GENDERS = [
  { value: 'female', text: 'Женский' },
  { value: 'male', text: 'Мужской' },
]

export const CALENDARS = [
  { value: 'bachelor', text: 'бакалавриата', link: 'https://abiturient.tusur.ru/ru/kak-postupit/ochnaya-forma-obucheniya?type=vst_ege,doc_budget,zach_budget,info' },
  { value: 'magistrant', text: 'магистратуры', link: 'https://magistrant.tusur.ru/ru/kak-postupit?type=vst_ege,vst_vi,doc_budget,doc_pvz,zach_budget,zach_pvz' },
  { value: 'aspirant', text: 'аспирантуры', link: 'https://postgraduate.tusur.ru/ru/aspirantura/kak-postupit' },
]

export const APPLICATION_EMAIL_NOT_MATCHED_TEXT = 'ВНИМАНИЕ! E-mail пользователя отличается от e-mail заявления.'
export const APPLICATION_EMAIL_NOT_MATCHED_TEXT_APPLICATION = 'E-mail пользователя отличается от e-mail заявления, Вы не сможете сдать вступительные испытания. Для изменения e-mail воспользуйтесь <a href="https://storage.tusur.ru/files/189990/2026-smena-log.pdf" target="_blank">инструкцией</a>.'
